// components/feedback/EmptyState.jsx
import React from 'react'
import { cn } from '../../lib/cn'

export function EmptyState({
  icon = '📭',
  title = 'Rien à afficher',
  description,
  action,
  className = '',
}) {
  return (
    <div className={cn(
      'rounded-3xl border border-slate-200 bg-white p-10 text-center shadow-sm',
      className
    )}>
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 text-2xl">
        {icon}
      </div>
      <div className="mt-4 text-lg font-bold text-slate-900">{title}</div>
      {description && (
        <div className="mt-1 text-sm text-slate-600">{description}</div>
      )}
      {action && (
        <div className="mt-6">
          {action}
        </div>
      )}
    </div>
  )
}
